module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    class: ['btn', _vm.disabled ? 'btn-outline-primary' : 'order-btn-active', 'mb-1'],
    attrs: {
      "type": "button",
      "id": "order-btn",
      "disabled": _vm.disabled,
      "title": _vm.title,
      "value": "Place order"
    },
    on: {
      "click": _vm.handleClick
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5718c664","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup/OrderButton.vue
// module id = 1326
// module chunks = 16